<app-black-container>
  <div class="complete-register">
    <h1 class="complete-register__title">
      {{ 'COMPLETE_REGISTRATION.TITLE' | translate }}
    </h1>
    <app-md-error-handler
      [error]="error"
      class="complete-register__banner"
    ></app-md-error-handler>
    <form
      (ngSubmit)="onSubmit(form)"
      #form="ngForm"
      class="complete-register__form"
    >
      <div>
        <div class="complete-register__name-input-container">
          <c-input-text
            required
            #firstNameRef="ngModel"
            [(ngModel)]="model.firstName"
            name="firstName"
            [label]="'REGISTER.GENERIC_FORM.FIRST_NAME' | translate"
            autocomplete="given-name"
            inputID="first-name-input"
            class="full-width"
            type="text"
          >
            <div role="alert" error-container>
              @if (!firstNameRef.valid && firstNameRef.touched) {
              <p class="complete-register__input--text-error">
                {{ "REGISTER.GENERIC_FORM.ERRORS.FIRST_NAME" | translate }}
              </p>
              }
            </div>
          </c-input-text>
          <c-input-text
            required
            #lastNameRef="ngModel"
            [(ngModel)]="model.lastName"
            name="lastName"
            [label]="'REGISTER.GENERIC_FORM.LAST_NAME' | translate"
            autocomplete="family-name"
            inputID="last-name-input"
            class="full-width"
            type="text"
          >
            <div role="alert" error-container>
              @if (!lastNameRef.valid && lastNameRef.touched) {
              <p class="complete-register__input--text-error">
                {{ "REGISTER.GENERIC_FORM.ERRORS.LAST_NAME" | translate }}
              </p>
              }
            </div>
          </c-input-text>
        </div>
        <div>
          <c-input-text
            required
            #passwordRef="ngModel"
            [label]="'REGISTER.GENERIC_FORM.PASSWORD.PASSWORD' | translate"
            name="password"
            [(ngModel)]="model.password"
            inputID="password-input"
            autocomplete="new-password"
            passwordVisibility
            showText="{{ 'LOGIN.PASSWORD_VISIBILITY_OFF' | translate }}"
            hideText="{{ 'LOGIN.PASSWORD_VISIBILITY_ON' | translate }}"
          >
            <div role="alert" error-container>
              @if ( passwordRef.touched && !passwordRef.valid ) { @if
              (passwordRef.errors?.required) {
              <p class="complete-register__input--text-error">
                {{ "REGISTER.GENERIC_FORM.ERRORS.PASSWORD" | translate }}
              </p>
              } @if (passwordRef?.errors?.knownBadPassword) {
              <p class="complete-register__input--text-error">
                {{ "REGISTER.GENERIC_FORM.ERRORS.PASSWORD_COMMON" | translate }}
              </p>
              } }
            </div>
            <c-password-strength-indicator
              content
              [control]="passwordRef.control"
              [passwordComplexity]="passwordComplexity"
            />
          </c-input-text>
        </div>
      </div>
      <div class="complete-register__checkbox-container">
        <div class="complete-register__checkbox-terms">
          <mat-checkbox
            name="terms"
            required
            [(ngModel)]="termsAccepted"
            #termsAcceptedRef="ngModel"
            [ngClass]="{
              invalid:
                termsAcceptedRef.errors?.required &&
                termsAcceptedRef.touched
            }"
            aria-labelledby="terms-description"
          >
          </mat-checkbox>
          <p id="terms-description">
            {{ "GENERAL.AGREE" | translate }}
            <a
              href="https://www.cariloop.com/terms-of-service/"
              target="_blank"
              class="complete-register__checkbox-terms-link"
              >{{ "GENERAL.TOS" | translate }}</a
            >
            {{ "GENERAL.AND" | translate }}
            <a
              href="https://www.cariloop.com/privacy-policy/"
              target="_blank"
              class="complete-register__checkbox-terms-link"
              >{{ "GENERAL.PRIVACY" | translate }}</a
            >
          </p>
        </div>
        <div role="alert">
          @if (termsAcceptedRef.errors?.required && termsAcceptedRef.touched) {
          <p
            class="complete-register__input--text-error complete-register__checkbox-error-text"
          >
            {{ "GENERAL.TOS_ERROR" | translate }}
          </p>
          }
        </div>
      </div>
      <div class="complete-register__button-container">
        @if (!isLoading) {
        <c-button
          buttonType="neutral"
          buttonStyle="fill"
          size="large"
          class="full-button"
          type="submit"
          [text]="'COMPLETE_REGISTRATION.SIGN_UP' | translate"
        >
        </c-button>
        } @if (isLoading) {
        <img src="assets/img/loader.png" alt="Loading" class="loading" />
        }
      </div>
    </form>
  </div>

  @if (showMobileAdoptionCTA) {
  <app-cta-mobile class="cta-mobile"></app-cta-mobile>
  }
</app-black-container>
